export const ADD_QUEEN = 'ADD_QUEEN';
export const REMOVE_QUEEN = 'REMOVE_QUEEN';
export const CLEAR_BOARD = 'CLEAR_BOARD';
export const SET_THEME = 'SET_THEME';
export const ADD_INVALID = 'ADD_INVALID';
export const REMOVE_INVALID = 'REMOVE_INVALID';
export const SET_FOCUS = 'SET_FOCUS';
